<template>
  <b-modal
    v-bind="$attrs"
    :visible="visible"
    v-on:hide="onHide"
    v-on:close="onClose"
    no-close-on-backdrop
    no-close-on-esc
  >
    <template #modal-title>
      <span class="text-blue-500 lead">
        <slot name="modal-title"></slot>
      </span>
    </template>
    <template #default>
      <slot></slot>
    </template>
    <template #modal-footer>
      <slot name="modal-footer"></slot>
    </template>
  </b-modal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

type Props = {
  modelValue: boolean
}

const props = defineProps<Props>()
const visible = ref(false)

watch(
  () => props.modelValue,
  (newValue) => {
    visible.value = newValue
  },
  { immediate: true }
)

const emit = defineEmits(['hide', 'close'])

function onHide(event: Event) {
  emit('hide', event)
}

function onClose(event: Event) {
  emit('close', event)
}
</script>

<style scoped></style>
